import { Button } from '@/components/ui/button'
import { Spinner } from '@/components/ui/spinner'
import Folder from '@/public/images/folder.svg'
import { ResponseDeliverableSet, ResponseDocumentListItem } from '@/schema'

import { TFLFileListItem } from '../TFLFileListItem'

interface TFLSidebarFileListProps {
  isLoading: boolean
  error: Error | null
  onRefetch: () => void
  sortedData: ResponseDocumentListItem[]
  activeDocumentId: string | null
  onFileClick: (item: ResponseDocumentListItem) => void
  onDeleteSingle: (item: ResponseDocumentListItem) => void
  onDeleteMulti: (item: ResponseDocumentListItem) => void
  onSelectDelete: (item: ResponseDocumentListItem) => void
  onDeselectDelete: (item: ResponseDocumentListItem) => void
  deliverableSet?: ResponseDeliverableSet | null
}

export const TFLSidebarFileList = ({
  isLoading,
  error,
  onRefetch,
  sortedData,
  activeDocumentId,
  onFileClick,
  onDeleteSingle,
  onDeleteMulti,
  onSelectDelete,
  onDeselectDelete,
  deliverableSet,
}: TFLSidebarFileListProps) => {
  if (isLoading) {
    return (
      <div className="flex items-center justify-center p-8">
        <Spinner />
      </div>
    )
  }

  if (error) {
    return (
      <div className="flex flex-col items-center justify-center p-8 space-y-4">
        <div className="text-center">
          <h3 className="text-sm font-semibold text-red-900 mb-2">
            Failed to load files
          </h3>
          <p className="text-xs text-red-700 mb-4">
            {error.message || 'Please try again later.'}
          </p>
          <Button onClick={onRefetch} variant="outlined" className="px-4 py-2">
            Reload
          </Button>
        </div>
      </div>
    )
  }

  if (sortedData.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center gap-3 text-center bg-white h-[480px] px-4">
        <div>
          <img src={Folder} alt="No data" className="h-12 mb-4 w-14" />
          <div className="flex flex-col gap-1">
            <h3 className="p-0 m-0 font-semibold text-primary-900 text-md">
              No files found
            </h3>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="space-y-1">
      {sortedData.map((item) => (
        <TFLFileListItem
          key={item.document_id}
          item={item}
          isActive={activeDocumentId === item.document_id}
          onClick={() => onFileClick(item)}
          onDeleteSingle={() => onDeleteSingle(item)}
          onDeleteMulti={() => onDeleteMulti(item)}
          onSelectDelete={() => onSelectDelete(item)}
          onDeselectDelete={() => onDeselectDelete(item)}
          deliverableSet={deliverableSet}
        />
      ))}
    </div>
  )
}
